import { createFileRoute } from '@tanstack/react-router';
import { NotificationSettingsPage } from '@/features/preparer/notifications/NotificationSettingsPage';

export const Route = createFileRoute('/preparer/notification-settings')({
  component: NotificationSettingsPage,
});
